<div class="d-flex flex-column justify-content-between assign-activity-header">
  <div class="mt-0 mb-3">
    {{ description | translate }}
  </div>
  <div class="mt-0 mb-3">
    <nz-form-item class="mb-0">
      <nz-form-control>
        <nz-select
          [nzPlaceHolder]="'general.select.placeholder' | translate"
          nzShowSearch
          nzAllowClear
          [nzShowArrow]="true"
          [(ngModel)]="priority"
        >
          @for (priority of priorities; track priority) {
            <nz-option [nzValue]="priority" [nzLabel]="priority"> </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
</div>
